<template>
  <div class="text-lg text-[#262626] font-semibold mb-5">
    <slot></slot>
  </div>
</template>
